import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl/dist';

import { setLoadedMessages, setMessages } from '../actions/common/actionCreators';

/**
 *
 * @param {Object} props
 * @returns {React.Component}
 *
 * Here we inject in pre-built component <IntlProvider/> messages
 * (they go from Redux Store on successful download from server)
 * and make <IntlProvider/> to update every time when we switch languages
 */
const ConnectedIntlProvider = props => {

    const {
        actions: {
            setLoadedMessages,
            setMessages
        },
        children,
        environment: {
            stateCode,
            language
        },
        messages,
        loadedLanguages
    } = props;

    useEffect(() => {
        if (stateCode) {
            const stateLocale = stateCode.toLowerCase();
            import(/* webpackChunkName: "test" */ /* webpackMode: "eager" */
                `../i18n/${stateLocale}/messages_${language}.json`)
                .then((messages) => {
                    setMessages(messages, language);

                    if(loadedLanguages && !loadedLanguages.includes(language)) { 
                        loadedLanguages.push(language);                      
                        setLoadedMessages(loadedLanguages);
                    }
                });


        }
    }, [ language, stateCode ]);

    return messages === null ? null :

        <IntlProvider
            locale={language}
            messages={messages}
        >
            { children }
        </IntlProvider>;
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    messages: state.common.messages && state.common.messages[state.common.environment.language],
    loadedLanguages: state.common.messages && state.common.messages.loadedLanguages
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        setLoadedMessages,
        setMessages
    }, dispatch)
});

export { ConnectedIntlProvider };

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedIntlProvider);
